'use strict';

import swal from 'sweetalert';

angular.module('docketbook').
  controller('adminAccountController', function ($location, $scope, $rootScope, Restangular, $state, $stateParams, accessControl, $timeout) {
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentUser = accessControl.currentUser();
    $scope.myAccount = true;
    $scope.pincodeActive = false;
    $scope.pincodeInput = '';
    $scope.verify = {};
    $scope.verify.loading = false;
    $scope.pass = {
      changingPassword: false
    };
    $scope.phoneRegister = {
      state: 'start'
    }
    $scope.emailRegister = {
      state: 'start'
    }

    var baseUser = Restangular.all('user');

    $scope.organisations = accessControl.allowedOrganisations();

    $rootScope.$on('OrganisationsListRefreshed', function () {
      $scope.organisations = accessControl.allowedOrganisations();
    });

    $rootScope.$on('ScopeUpdated', function () {
      $scope.currentOrg = accessControl.currentOrg();
      $scope.currentOrgGroup = accessControl.currentOrgGroup();
      $scope.closeScopeDropdown();
    });

    /* Create a new company */
    $scope.newCompany = function (isSampleCompany) {
      $scope.closeScopeDropdown();
      $scope.createNewCompanyFromParent(isSampleCompany, function (newOrg) {
        if (newOrg != null) {
          $state.go('main.groupDashboard', { orgId: newOrg.id });
        }
      });
    }

    /********************************/
    /***** Account Funtionality *****/
    /********************************/

    function getCurrentUserActual() {
      var addresses = [$scope.currentUser.emailAddress];
      $scope.currentUser.emailAddresses.forEach(function (addr) {
        if (addresses.indexOf(addr) === -1) {
          addresses.push(addr);
        }
      })

      addresses.forEach(function (addr) {
        var left = addr.split('@')[0];
        if ((left[0] === '+') && (!isNaN(left.substring(1)))) {
          $scope.currentUser.hasPhoneNumber = true;
          if (!$scope.currentUser.realPhoneNumber) {
            var adjusted = '0' + left.substring(3);
            $scope.currentUser.realPhoneNumber = adjusted;
          }
          //need to check if its unverified
          var isUnverified = false;
          if ($scope.currentUser.unverifiedPrincipals) {
            $scope.currentUser.unverifiedPrincipals.forEach((prin) => {
              if (prin === addr) {
                isUnverified = true;
              }
            })
          }
          if (isUnverified) {
            $scope.currentUser.hasUnverifiedPhoneNumber = true;
            $scope.currentUser.unverifiedPhoneNumber = addr;
          }
        } else {
          $scope.currentUser.hasEmailAddress = true;
          if (!$scope.currentUser.realEmailAddress) {
            $scope.currentUser.realEmailAddress = addr;
          }
        }
      })
      $scope.currentUser.loading = false;
      $scope.userOriginal = angular.copy($scope.currentUser);
      return;
    }

    getCurrentUserActual();

    $scope.updateAccountForNotifications = function () {
      $scope.currentUser.loading = true;
      var sendData = {
        preferEmailNotifications: $scope.currentUser.preferEmailNotifications,
        docketPdfInNotifications: $scope.currentUser.docketPdfInNotifications,
        receiveSelfNotifications: $scope.currentUser.receiveSelfNotifications,
        receiveOrderNotifications: $scope.currentUser.receiveOrderNotifications
      };
      baseUser.customPUT(sendData).then($scope.updateAccountSuccess, $scope.updateAccountFailure);
    }

    $scope.updateAccount = function (isValid) {
      $scope.currentUser.loading = true;
      var sendData = {};
      var keys = Object.keys($scope.currentUser);
      keys.forEach(function (key) {
        if (key != 'password' && key != 'pinCode') {
          if (!angular.equals($scope.currentUser[key], $scope.userOriginal[key])) {
            sendData[key] = $scope.currentUser[key];
          }
        }
        if (sendData.name != null && sendData.name.full != null) {
          delete sendData.name.full;
        }
      });

      if ($scope.currentUser.password) {
        sendData.password = $scope.currentUser.password;
      }
      if ($scope.currentUser.pinCode) {
        sendData.pinCode = $scope.currentUser.pinCode;
      }

      delete sendData.loading;

      baseUser.customPUT(sendData).then($scope.updateAccountSuccess, $scope.updateAccountFailure);
    }
    $scope.changePassword = function (isValid) {
      if ($scope.pass.password !== $scope.pass.confirmPassword) {
        swal({
          title: "Oops!",
          text: "Your passwords do not match.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        return;
      }
      var sendData = {
        password: $scope.pass.password
      }
      baseUser.one('password').customPUT(sendData)
        .then(function (result) {
          swal("Password updated!", "Use your new password when you login next time", "success");
        }).catch(function (err) {
          swal({
            title: "Oops!",
            text: "We couldn't update your password. Please try again later",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        })
    }

    $scope.registerPhoneNumber = function () {
      if (($scope.phoneRegister.phoneNumber.length !== 10)
        || ($scope.phoneRegister.phoneNumber.substring(0, 2) !== '04')) {
        swal({
          title: "Oops!",
          text: "Please enter a valid mobile phone number",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        return
      }
      var adjusted = "+61" + $scope.phoneRegister.phoneNumber.substring(1);
      var postObj = {
        address: adjusted
      };
      return baseUser.one('address').customPOST(postObj).then(function (result) {
        $scope.verifyPledge = result;
        $scope.phoneRegister.state = 'verify';
      }).catch(function (err) {
        if (err.status === 409) {
          swal({
            title: "Oops!",
            text: "That number is already registered to another user.",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        } else {
          swal({
            title: "Oops!",
            text: "Unable to register your number. Please try again later",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        }
      })
    }

    $scope.registerEmailAddress = function () {
      var postObj = {
        address: $scope.emailRegister.emailAddress
      };
      return baseUser.one('address').customPOST(postObj).then(function (result) {
        $scope.emailRegister.state = 'verify';
      }).catch(function (err) {
        if (err.status === 409) {
          swal({
            title: "Oops!",
            text: "That email address is already registered to another user.",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        } else {
          swal({
            title: "Oops!",
            text: "Unable to register your number. Please try again later",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        }
      })
    }

    $scope.verifyPhoneNumber = function () {
      if ($scope.phoneRegister.verificationCode.length !== 6) {
        swal({
          title: "Oops!",
          text: "The verification code needs to be 6 digits",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        return
      }
      return baseUser
        .one('address')
        .one($scope.verifyPledge.id)
        .one('verify')
        .customPUT({
          secret: $scope.phoneRegister.verificationCode
        }).then(function (result) {
          $scope.phoneRegister.state = 'done';
          $scope.currentUser.hasPhoneNumber = true;
          $scope.currentUser.realPhoneNumber = $scope.phoneRegister.phoneNumber;
        })
    }

    $scope.confirmUnverifiedPhoneNumber = function () {
      if ($scope.phoneRegister.verificationCode.length !== 6) {
        swal({
          title: "Oops!",
          text: "The verification code needs to be 6 digits",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        return
      }
      return baseUser
        .one('principal')
        .customPOST({
          principal: $scope.currentUser.unverifiedPhoneNumber,
          secret: $scope.phoneRegister.verificationCode
        }).then(function (result) {
          delete $scope.currentUser.unverifiedPhoneNumber;
          $scope.currentUser.hasUnverifiedPhoneNumber = false;
          $scope.phoneRegister.state = 'done';
          accessControl.refreshCurrentUser();
        })
    }

    $scope.updateAccountSuccess = function () {
      getCurrentUserActual($stateParams.currentUser.id);
      swal("Account updated!", "Changes will be effective the next time you log in.", "success");
    }

    $scope.updateAccountFailure = function (err) {
      $scope.currentUser.loading = false;
      swal({
        title: "Oops!",
        text: "Something bad happened while we were trying to update your account, please try again.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
    }

    $scope.setPincode = function () {
      $scope.pincodeActive = true;
      $("#pincodeModal").fadeIn(100);
    }

    /* Pincode functionality */
    var resetPincode = function () {
      var dotCount = [1, 2, 3, 4];
      var numberCount = [1, 2, 3, 4, 5, 6, 7, 8, 9];
      $scope.pincodeInput = '';
      $timeout(function () {
        dotCount.forEach(function (dotNumber) {
          $("#dot" + dotNumber).removeAttr('class');
          $("#dot" + dotNumber).attr('class', 'dot');
          $("#dot" + dotNumber)[0].className = 'dot';
        });
        numberCount.forEach(function (number) {
          $("#number" + number).removeAttr('class');
          $("#number" + number).attr('class', 'number');
          $("#number" + number)[0].className = 'number';
        });
      }, 1000);
    }

    $scope.closePincodeModal = function () {
      resetPincode();
      $scope.pincodeActive = false;
      $("#pincodeModal").fadeOut(100);
    }

    /* Pincode Functionality */
    $scope.pinPress = function (number) {
      var dotCount = [1, 2, 3, 4];
      $scope.pincodeInput += number;
      $("#number" + number).addClass('grow');
      $("#dot" + $scope.pincodeInput.length).addClass('active');
      $timeout(function () {
        $("#number" + number).removeAttr('class');
        $("#number" + number).attr('class', 'number');
        $("#number" + number)[0].className = 'number';
      }, 900);
      if ($scope.pincodeInput.length >= 4) {
        // add pincode to user account
        $scope.currentUser.pinCode = $scope.pincodeInput;
        $scope.closePincodeModal();
      }
    }

    $(document).on('keypress', function (e) {
      var charCode = e.charCode;
      if ($scope.pincodeActive && charCode >= 49 && charCode <= 57) {
        var number = charCode - 48;
        if (number > 0) {
          $scope.pinPress(number);
        }
      }
    });

    /* PHONE VERIFICATION */
    $scope.checkVerificationCode = function () {
      $scope.verify.loading = true;
      var postObj = {};
      postObj.phoneNumber = $scope.currentUser.phoneNumber;
      postObj.verificationCode = $scope.verify.verificationCode;
      Restangular.all('verify').all('phone').customPOST(postObj).then(function () {
        $scope.verify = {};
        // TODO: update the user account
        delete $scope.currentUser.phoneVerificationCode;
        // verify code correct -success
      }, function (err) {
        // error occured during verification
        $scope.verify.loading = false;
        alert('err');
      });
    }


    /*** ORG SCOPE FUNCTIONS - FOR MOBILE ****/
    $scope.openScopeDropdown = function () {
      $(".mobileSideNav").animate({
        left: "0px"
      }, 400);
      /*$("body").addClass('noscroll');*/
    }

    $scope.closeScopeDropdown = function () {
      $(".mobileSideNav").animate({
        left: "-90%"
      }, 400);
      /*$("body").removeClass('noscroll');*/
    }

    $scope.changeOrganisation = function (org) {
      if (org != null) {
        var locatedOrgGroup = null;
        for (var i = 0; i < org.groups.length; i++) {
          if (org.groups[i].parent == null) {
            locatedOrgGroup = org.groups[i];
            break;
          }
        }
        if (locatedOrgGroup == null && org.groups && org.groups.length > 0) {
          locatedOrgGroup = org.groups[0];
        }
        $scope.changeOrganisationGroup(org, locatedOrgGroup);
      } else {
        $state.go('main.dashboard');
      }
    }

    $scope.changeOrganisationGroup = function (org, orgGroup) {
      accessControl.getOrgPagePermissions(org, orgGroup, function (res) {
        var permissions = res.permissions[$scope.currentUser.id];
        if (permissions.indexOf('group-owner') != -1 || permissions.indexOf('global-administrator') != -1) {
          $state.go('main.groupOrders', { orgId: org.id, groupId: orgGroup.id });
        } else if (permissions.indexOf('io.docketbook.ojdapi.getOrder') != -1) {
          $state.go('main.groupOrders', { orgId: org.id, groupId: orgGroup.id });
        } else if (permissions.indexOf('io.docketbook.ojdapi.getJob') != -1 || permissions.indexOf('io.docketbook.ojdapi.getMyJob') != -1) {
          $state.go('main.groupJobs', { orgId: org.id, groupId: orgGroup.id });
        } else if (permissions.indexOf('io.docketbook.ojdapi.getDocket') != -1 || permissions.indexOf('io.docketbook.ojdapi.getMyDocket') != -1) {
          $state.go('main.groupDockets', { orgId: org.id, groupId: orgGroup.id });
        } else {
          $state.go('main.groupDashboard', { orgId: org.id, groupId: orgGroup.id });
        }
      });
    }

    $scope.logout = function () {
      window.location.href = "/v1/logout";
    }

    /******** END TEST ORG SCOPE STUFF ************/
    /*************************/
    /***** Intercom JS API  **/
    /*************************/

    $scope.openIntercom = function () {
      window.FreshworksWidget('open', 'ticketForm')
    }

    /***********************/
    /***** Permissions *****/
    /***********************/

    /* F/E Permission Checking */
    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/admin.js